/**
 * ErrorBoundary — catches any uncaught render error below it and displays
 * a reload prompt. Otherwise renders children transparently.
 *
 * Moved from App.js in PR C-2 Move 1 of Option C.
 *
 * Palette values inlined (T.bg = #0B1120, T.text = #F1F5F9, T.sub = #CBD5E1,
 * C.teal = #007CBE) pending PR C-5 palette flip to cyan+black tokens.
 */

import React from "react";

export class ErrorBoundary extends React.Component {
  state = { hasError: false, error: null };

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("Dashboard error:", error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#0B1120",
          fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif",
        }}>
          <div style={{ textAlign: "center", maxWidth: 420, padding: 32 }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>&#9888;</div>
            <h2 style={{ color: "#F1F5F9", fontSize: 20, fontWeight: 700, marginBottom: 8 }}>
              Something went wrong
            </h2>
            <p style={{ color: "#CBD5E1", fontSize: 14, marginBottom: 24, lineHeight: 1.5 }}>
              The dashboard encountered an unexpected error. Please reload the page to continue.
            </p>
            <button
              onClick={() => window.location.reload()}
              style={{
                padding: "10px 28px",
                borderRadius: 8,
                border: "none",
                cursor: "pointer",
                background: "#007CBE",
                color: "#fff",
                fontSize: 14,
                fontWeight: 600,
              }}
            >
              Reload Dashboard
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
